import React, { 
    useState, 
    useEffect,
    useCallback } from 'react';
import {
    Button,
    Form,
    Input,
    Radio,
    Select,
    notification,
    Result,
    Tooltip,
    Alert,
    DatePicker,
    Checkbox
} from 'antd';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import MaskedInput from "antd-mask-input";
import moment from "moment/moment";
import dayjs from "dayjs";
import axios from 'axios';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    PlusOutlined,
    QuestionCircleOutlined
} from '@ant-design/icons';

import TransferNumber from './TransferNumber';
import QualificationFormStandalone from '../ecomm/tools/QualificationFormStandalone';

//import CCTSLogo from '../../images/ccts-logo.png';

function TransferForm() {

    const { executeRecaptcha } = useGoogleReCaptcha();
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;
    const [api, contextHolder] = notification.useNotification();
    const [submissionResult, setSubmissionResult] = useState(<></>);
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [showForm, setShowForm] = useState( true );
    
    const [servicePlanSelection, setServicePlanSelection] = useState( '' );
    const [servicePlanStatus, setServicePlanStatus] = useState('');

    const [phoneProviderSelection, setPhoneProviderSelection] = useState( '' );
    const [phoneProviderStatus, setPhoneProviderStatus] = useState( '' );

    const [phoneProviderOtherValidSuffix, setPhoneProviderOtherValidSuffix] = useState( <></> );
    const [phoneProviderOtherStatus, setPhoneProviderOtherStatus] = useState( '' );
    const [phoneProviderOther, setPhoneProviderOther] = useState( '' );
    const [phoneProviderOtherValid, setPhoneProviderOtherValid] = useState( false );

    const [internetProviderSelection, setInternetProviderSelection] = useState( '' );
    const [internetProviderStatus, setInternetProviderStatus] = useState( '' );

    const [customerNumberValidSuffix, setCustomerNumberValidSuffix] = useState(<></>);
    const [customerNumber, setCustomerNumber] = useState('');
    const [customerNumberValid, setCustomerNumberValid] = useState(false);
    const [customerNumberStatus, setCustomerNumberStatus] = useState('');    

    const [customerNameValidSuffix, setCustomerNameValidSuffix] = useState(<></>);
    const [customerName, setCustomerName] = useState('');
    const [customerNameValid, setCustomerNameValid] = useState(false);
    const [customerNameStatus, setCustomerNameStatus] = useState('');

    const [numberToRemove, setNumberToRemove] = useState(null);
    const [numberTransferFields, setNumberTransferFields] = useState([]);

    const [customerPhoneNumberValid, setCustomerPhoneNumberValid] = useState(null);

    const [qualificationAddress, setQualificationAddress] = useState(null);
    const [qualificationAddressUnit, setQualificationAddressUnit] = useState('');
    const [qualificationAddressStatus, setQualificationAddressStatus] = useState(null);

    const [transferDate, setTransferDate] = useState('');
    const [transferDateStatus, setTransferDateStatus] = useState('');

    const [isAuthorizedAccountHolder, setIsAuthorizedAccountHolder] = useState(false);
    const [isAuthorizedAccountHolderStatus, setIsAuthorizedAccountHolderStatus] = useState('');
    const [addressConfirmation, setAddressConfirmation] = useState(false);
    const [addressConfirmationStatus, setAddressConfirmationStatus] = useState('');
    const [residentialConfirmation, setResidentialConfirmation] = useState(false);
    const [residentialConfirmationStatus, setResidentialConfirmationStatus] = useState('');
    const [transferNumberStatus, setTransferNumberStatus] = useState('');
    const [numbersToTransfer, setNumbersToTransfer] = useState([]);

    const [radioTransferType, setRadioTransferType] = useState('');
    const [radioTransferTypeStatus, setRadioTransferTypeStatus] = useState( '' );

    const [radioPlanType, setRadioPlanType] = useState('');
    const [radioPlanTypeStatus, setRadioPlanTypeStatus] = useState( '' );

    const [imeiValidSuffix, setimeiValidSuffix] = useState(<></>);
    const [imeiNumber, setImeiNumber] = useState('');
    const [imeiValid, setimeiValid] = useState(false);
    const [imeiStatus, setimeiStatus] = useState('');

    const [wirelessAccountValidSuffix, setWirelessAccountValidSuffix] = useState(<></>);
    const [wirelessAccountNumber, setWirelessAccountNumber] = useState('');
    const [wirelessAccountValid, setWirelessAccountValid] = useState(false);
    const [wirelessAccountStatus, setWirelessAccountStatus] = useState('');

    const disabledDates = ['2024-02-19', '2024-03-29', '2024-04-01', '2024-05-20', '2024-06-01', '2024-09-02', '2024-09-30', '2024-10-14', '2024-11-11', '2024-12-25', '2024-12-26', '2025-01-01'];

    let phoneNumberInputMarkup = [];

    useEffect(() => {

        if( numberTransferFields.length === 0 ) {
            setNumberTransferFields( [...numberTransferFields, 
                <TransferNumber 
                    inputId={ 0 }
                    key={ 0 }
                    setCustomerPhoneNumberValid={ setCustomerPhoneNumberValid }
                    handleRemoveFromCustomerPhoneNumberArray={ handleRemoveFromCustomerPhoneNumberArray }
                    showAddInputButton={ true }
                    showRemoveInputButton={ false }
                    setTransferNumberStatus={ setTransferNumberStatus }
                    transferNumberStatus={ transferNumberStatus }
                />
            ] );
        }

        if( numberToRemove ) {
            let fieldsAry = [];

            for( let i=0; i < numberTransferFields.length; i++ ) {
                if( numberTransferFields[i].key != numberToRemove ) {
                    fieldsAry.push( numberTransferFields[i] );
                }
            }

            setNumberTransferFields( fieldsAry );
            setNumberToRemove( null );
        }
        
    }, [ 
        numberTransferFields,
        numberToRemove ]);

    const onTransferRadioChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );
    }

    const handleReCaptchaVerify = useCallback(async ( transferNumberInputStr ) => {
        if (!executeRecaptcha) {
          console.log('Execute recaptcha not yet available');
          return;
        }

        const token = await executeRecaptcha('success');
        console.log("token: ", token);
        console.log( 'CUSTOMER', customerName );
        console.log( 'SERVICE', servicePlanSelection );
        console.log( 'NUMBERS', transferNumberInputStr );
        console.log( 'TRANSFER_DATE', transferDate );
        console.log( 'ADDRESS', qualificationAddress );
        console.log( 'UNIT', qualificationAddressUnit );
        console.log( 'PROVIDER_INPUT', phoneProviderSelection );
        console.log( 'PROVIDER_INPUT_OTHER', phoneProviderOther );
        console.log( 'INTERNET_INPUT', internetProviderSelection );
        console.log( 'CONFIRM_OWNER', isAuthorizedAccountHolder );
        console.log( 'CONFIRM_ADDRESS', addressConfirmation );
        console.log( 'CONFIRM_RESIDENTIAL', residentialConfirmation );
        console.log( 'IMEI_NUMBER', imeiNumber );

        let form_data = new FormData;
        form_data.append('action', 'handle_port_transfer_request');
        form_data.append('token', token);
        form_data.append('TYPE', 'Residential');
        form_data.append('CUSTOMER', customerName);
        form_data.append('CUSTOMER_NUMBER', customerNumber);
        form_data.append('SERVICE', servicePlanSelection);
        form_data.append('NUMBERS', transferNumberInputStr);
        form_data.append('TRANSFER_DATE', transferDate);
        form_data.append('ADAPTER', '');
        form_data.append('NAME', 'Residential');
        form_data.append('ADDRESS', qualificationAddress);
        form_data.append('UNIT', qualificationAddressUnit);
        form_data.append('PROVIDER_INPUT', phoneProviderSelection);
        form_data.append('PROVIDER_INPUT_OTHER', phoneProviderOther);
        form_data.append('TRANSFER_TYPE', radioTransferType);

        if( radioTransferType == 'transferring-wireless' ) {
            form_data.append('WIRELESS_PLAN_TYPE', radioPlanType);

            if( radioPlanType == 'payg' ) {
                form_data.append('IMEI_NUMBER', imeiNumber);
            } else {
                form_data.append('WIRELESS_ACCOUNT_NUMBER', wirelessAccountNumber);
            }
        }

        form_data.append('INTERNET_INPUT', internetProviderSelection);
        form_data.append('CONFIRM_OWNER', isAuthorizedAccountHolder);
        form_data.append('CONFIRM_ADDRESS', addressConfirmation);
        form_data.append('CONFIRM_RESIDENTIAL', residentialConfirmation);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log( 'response:: ', response.data );
            setFormSubmitting( false );

            switch( response.data ) {
                case 'success':
                    setShowForm( false );
                    setSubmissionResult( 
                        <Result
                            status="success"
                            title="We've received your transfer request!"
                            subTitle="A member of our Support team will be in touch with you shortly."
                            extra={[]}
                        />
                    );
                break;

                case 'failed-captcha':
                setSubmissionResult( 
                    <Result
                        status="error"
                        title="Submission failed!"
                        subTitle="There was a problem submitting your request. Please try again later."
                        extra={[]}
                    />
                 );
                break;
            }

        })
        .catch(function (error) {
            console.log(error);
            setSubmissionResult( 
                <Result
                    status="error"
                    title="Submission failed!"
                    subTitle="There was a problem submitting your request. Please try again later."
                    extra={[]}
                />
             );
        })
        .finally(function () {
            // always executed 
        });

    }, [executeRecaptcha,
        customerName,
        numbersToTransfer,
        transferDate,
        servicePlanSelection,
        qualificationAddress,
        qualificationAddressUnit,
        phoneProviderSelection,
        phoneProviderOther,
        internetProviderSelection,
        isAuthorizedAccountHolder,
        addressConfirmation,
        residentialConfirmation,
        setFormSubmitting,
        setShowForm
    ]);

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'transfer-form-customer-number': 
                if( currentVal.length < 3 ){ 
                    isValid = false;
                }

                if( currentVal != '' ) {
                    validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;
                }

                let customerNumber = isValid ? currentVal : '';

                setCustomerNumberValid( isValid );
                setCustomerNumber( customerNumber );
                setCustomerNumberValidSuffix( validationSuffix );
                setCustomerNumberStatus('');
                
                if( !isValid ) { }
            break;

            case 'transfer-form-customer-name':
                if( currentVal.length < 3 ){ 
                    isValid = false;
                }

                if( currentVal != '' ) {
                    validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;
                }

                let customerName = isValid ? currentVal : '';

                setCustomerNameValid( isValid );
                setCustomerName( customerName );
                setCustomerNameValidSuffix( validationSuffix );
                setCustomerNameStatus( '' );
                
                if( !isValid ) { }
            break;

            case 'phone-provider-other-input' :
                if( currentVal.length < 3 ){ 
                    isValid = false;
                }

                if( currentVal != '' ) {
                    validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;
                }

                let providerOther = isValid ? currentVal : '';

                setPhoneProviderOtherValid( isValid );
                setPhoneProviderOther( providerOther );
                setPhoneProviderOtherValidSuffix( validationSuffix );
                setPhoneProviderOtherStatus( '' );
                
                if( !isValid ) { }
            break;

            case 'transfer-form-imei-number' :
                if( currentVal.length < 3 ){ 
                    isValid = false;
                }

                if( currentVal != '' ) {
                    validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;
                }

                let imeiValidVal = isValid ? currentVal : '';

                setimeiValid( isValid );
                setImeiNumber( imeiValidVal );
                setimeiValidSuffix( validationSuffix );
                setimeiStatus( '' );
                
                if( !isValid ) { }
            break;

            case 'transfer-form-wireless-account-number' :
                if( currentVal.length < 3 ){ 
                    isValid = false;
                }

                if( currentVal != '' ) {
                    validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;
                }

                let wirelessAccountValidVal = isValid ? currentVal : '';

                setWirelessAccountValid( isValid );
                setWirelessAccountNumber( wirelessAccountValidVal );
                setWirelessAccountValidSuffix( validationSuffix );
                setWirelessAccountStatus( '' );
                
                if( !isValid ) { }
            break;
        }
    }

    const handleChangeServicePlanSelection = ( value ) => {
        setServicePlanSelection( value );
        setServicePlanStatus('');
    }

    const handleChangePhoneProviderSelection = ( value ) => {
        setPhoneProviderSelection( value );
        setPhoneProviderStatus('');
    }

    const handleChangeInternetProviderSelection = ( value ) => {
        setInternetProviderSelection( value );
        setInternetProviderStatus( '' );
    }

    const onChangeActivationDate = ( date, dateString ) => {
        //console.log("date: ", date);
        //console.log("dateString: ", dateString);
        setTransferDate( dateString );
    }

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );
    }

    const handleAddNumberInput = () => {

        if( numberTransferFields.length <= 3 ) {
            setNumberTransferFields( [...numberTransferFields, 
                <TransferNumber 
                    inputId={ numberTransferFields.length }
                    key={ numberTransferFields.length }
                    setCustomerPhoneNumberValid={ setCustomerPhoneNumberValid }
                    handleRemoveFromCustomerPhoneNumberArray={ handleRemoveFromCustomerPhoneNumberArray }
                    showRemoveInputButton={ ( numberTransferFields.length <= 0 ) ? false : true }
                    transferNumberStatus={ transferNumberStatus }
                    setTransferNumberStatus={ setTransferNumberStatus }
                />
            ] );
        }

        setCustomerPhoneNumberValid( false );
    }

    const handleRemoveFromCustomerPhoneNumberArray = ( inputToRemove ) => {
        setNumberToRemove( inputToRemove );
    }

    const disabledDate = (current) => {
        let theD = new Date(current);
        let theDFormated = moment(theD).format("YYYY-MM-DD");
        let leadTime = 6;
        let canDoSaturdays = '';

        return (
            current < moment().add(leadTime, 'days') ||
            new Date(current).getDay() === 0 ||
            new Date(current).getDay() === 6 ||
            disabledDates.find( date => date === theDFormated )
        );
    }

    const onCheckboxChange = ( e ) => {
        let checkId = e.target.id;
        let isChecked = e.target.checked;
        //console.log( "checkId: ", checkId );
        //console.log( "isChecked: ", isChecked );

        switch( checkId ) {
            case 'authorized-account-holder-checkbox':
                setIsAuthorizedAccountHolder( isChecked );
                setIsAuthorizedAccountHolderStatus('');
            break;
            case 'address-confirmation-checkbox':
                setAddressConfirmation( isChecked );
                setAddressConfirmationStatus('');
            break;
            case 'residential-service-confirmation-checkbox': 
                setResidentialConfirmation( isChecked );
                setResidentialConfirmationStatus( '' );
            break;
        }
    }

    const onRadioPlanTypeChange = ( e ) => {
        let valueChecked = e.target.value;
        console.log('valueChecked: ', valueChecked);
        setRadioPlanType( valueChecked );
        setRadioPlanTypeStatus( '' );
    }

    const onRadioTransferChange = ( e ) => {
        let valueChecked = e.target.value;
        console.log('valueChecked: ', valueChecked);

        setRadioTransferType( valueChecked );
        setRadioTransferTypeStatus( '' );
    }

    const handleValidateInputs = () => {
        let formValid = true;
        setFormSubmitting( true );

        if( servicePlanSelection == '' ||
            qualificationAddress == '' ||
            phoneProviderSelection == '' ||
            internetProviderSelection == '' ||
            transferDate == '' ||
            isAuthorizedAccountHolder == '' ||
            residentialConfirmation == '' ||
            addressConfirmation == '' ||
            !customerNameValid ||
            radioTransferType == ''
         ) {
            formValid = false;
        }

        if( phoneProviderSelection == 'other' && phoneProviderOther == '' ) {
            formValid = false;
        }

        if( radioTransferType == 'transferring-wireless' && radioPlanType == '' ) {
            formValid = false;
        }

        if( radioTransferType == 'transferring-wireless' && radioPlanType == 'payg' && imeiNumber == '' ) {
            formValid = false;
        }

        if( radioTransferType == 'transferring-wireless' && radioPlanType == 'monthly' && wirelessAccountNumber == '' ) {
            formValid = false;
        }

        setCustomerNumberStatus( ( customerNumberValid ) ? '' : 'error' );
        setServicePlanStatus( ( servicePlanSelection != '' ) ? '' : 'error' );
        setCustomerNameStatus( ( customerNameValid ) ? '' : 'error' );
        setQualificationAddressStatus( ( qualificationAddress != '' && qualificationAddress != null ) ? '' : 'error' );
        setPhoneProviderStatus( ( phoneProviderSelection != '' ) ? '' : 'error' );

        setPhoneProviderOtherStatus( ( phoneProviderOtherValid != '' ) ? '' : 'error' );

        setInternetProviderStatus( ( internetProviderSelection != '' ) ? '' : 'error');
        setTransferDateStatus( (transferDate != '') ? '' : 'error' );
        setIsAuthorizedAccountHolderStatus( ( isAuthorizedAccountHolder != '' && isAuthorizedAccountHolder != false ) ? '' : 'error') ;
        setResidentialConfirmationStatus( ( residentialConfirmation != '' && residentialConfirmation != false ) ? '' : 'error');
        setAddressConfirmationStatus( ( addressConfirmation != '' && addressConfirmation != false ) ? '' : 'error');

        setRadioTransferTypeStatus(( radioTransferType != '' ) ? '' : 'error');
        setRadioPlanTypeStatus(( radioTransferType == 'transferring-wireless' && radioPlanType != '' ) ? '' : 'error');
        setimeiStatus( ( imeiNumber != '' ) ? '' : 'error' );
        setWirelessAccountStatus( ( wirelessAccountNumber != '' ) ? '' : 'error' );

        let transferNumberInputs = [];

        for( let i=0; i < 3 ; i++ ) {
            let transferInput = (jQuery('#transfer-form-customer-phone-number'+i).val()) ? jQuery('#transfer-form-customer-phone-number'+i).val() : '';

            if( !transferInput.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im) ) {
                //
            }else {
                transferNumberInputs.push( transferInput )
            }
        }

        setNumbersToTransfer(transferNumberInputs);
        let transferNumberInputStr = transferNumberInputs.toString()

        //console.log('transferNumberInputs::: ', transferNumberInputs.toString() );

        if( !transferNumberInputs.length ) {
            setTransferNumberStatus('error');
            formValid = false;


            setNumberTransferFields( [ 
                <TransferNumber 
                    inputId={ 0 }
                    key={ 0 }
                    setCustomerPhoneNumberValid={ setCustomerPhoneNumberValid }
                    setTransferNumberStatus={ setTransferNumberStatus }
                    handleRemoveFromCustomerPhoneNumberArray={ handleRemoveFromCustomerPhoneNumberArray }
                    showAddInputButton={ true }
                    showRemoveInputButton={ false }
                    transferNumberStatus={ 'error' }
                />
            ] );
        }

        if( !formValid ) {
            setSubmissionResult( <Alert style={ {marginTop:'1rem'} } message="Please fix the issues highlighted above and try again." type="error" /> );
            setFormSubmitting( false );
        }else {
            setSubmissionResult( <></> );
            handleReCaptchaVerify( transferNumberInputStr );
        }
    }

    return (
        <div className='default-menu-items number-transfer-form-input-container'>
            <div className='support-links-container' style={ { display: ( showForm ) ? 'block' : 'none' } }>
                <h4>Number transfer form</h4>
                <p>Please ensure all of your details are accurate.</p>

                <Form 
                    form={ form }
                > 
                    <div className="form-column-row">
                        <Form.Item
                            label="Start customer number (leave blank if unknown)"
                            labelCol={{ span: 24 }}
                            name="customer-number"
                            style={{paddingRight:'1rem'}}
                            rules={[
                                {
                                required: false,
                                message: '',
                                },
                            ]}
                        >
                            <Input
                                id="transfer-form-customer-number"
                                suffix={ customerNumberValidSuffix }
                                autoFocus
                                //status={ customerNumberStatus }
                                onChange={handleOnInputChange}
                                defaultValue={ customerNumber }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Service plan"
                            labelCol={{ span: 24 }}
                            name="service-plan"
                            rules={[
                                {
                                required: true,
                                message: 'Please select a service plan!',
                                },
                            ]}
                        >
                            <Select
                                id="service-plan-input"
                                name="service-plan-input"
                                defaultValue="Select"
                                status={ servicePlanStatus }
                                onChange={handleChangeServicePlanSelection}
                                options={[
                                    {
                                    value: 'digital-voice-canada',
                                    label: 'Digital Voice Canada',
                                    },
                                    {
                                    value: 'digital-voice-canada-and-usa',
                                    label: 'Digital Voice Canada and USA',
                                    },
                                    {
                                    value: 'digital-voice-world',
                                    label: 'Digital Voice World',
                                    }
                                ]}
                            />
                        </Form.Item>
                    </div>

                    <div className='number-transfer-phone-number-fields'>
                        <div className="number-transfer-fields-container">
                            { numberTransferFields }
                        </div>
                        <Button
                            style={{ display: 'inline-block', marginTop: '-15px' }} 
                            disabled={ ( numberTransferFields.length >= 4 || !customerPhoneNumberValid ) ? true : false }
                            shape="circle"
                            type='primary'
                            size='medium'
                            icon={<PlusOutlined />}
                            onClick={ handleAddNumberInput }
                        />
                    </div>

                    <p style={{ marginTop:'2rem' }}>Please enter the details from your current phone bill, including the service address:</p>

                    <div className="form-column-row">
                        <Form.Item
                            label="Account holder (your name as it appears on the bill)"
                            labelCol={{ span: 24 }}
                            name="customer-name"
                            style={{paddingRight:'1rem'}}
                            rules={[
                                {
                                required: true,
                                message: 'Please enter your account holder name from a current phone bill.',
                                },
                            ]}
                        >
                            <Input
                                id="transfer-form-customer-name"
                                suffix={ customerNameValidSuffix }
                                status={ customerNameStatus }
                                onChange={handleOnInputChange}
                                defaultValue={ customerName }
                            />
                        </Form.Item>

                        <QualificationFormStandalone
                            qualificationAddressStatus={ qualificationAddressStatus }
                            setQualificationAddressStatus={ setQualificationAddressStatus }
                            setQualificationAddress={ setQualificationAddress }
                            setQualificationAddressUnit={ setQualificationAddressUnit }
                        />
                    </div>

                    <div className='form-column-row inline spaced'>
                        <Form.Item
                            label="Phone provider"
                            labelCol={{ span: 24 }}
                            name="phone-provider"
                            rules={[
                                {
                                required: true,
                                message: 'Please select you current phone provider!',
                                },
                            ]}
                        >
                            <Select
                                id="phone-provider-input"
                                name="phone-provider-input"
                                status={ phoneProviderStatus }
                                defaultValue="Select"
                                onChange={handleChangePhoneProviderSelection}
                                options={[
                                    {
                                    value: 'bell',
                                    label: 'Bell',
                                    },
                                    {
                                    value: 'rogers',
                                    label: 'Rogers',
                                    },
                                    {
                                    value: 'telus',
                                    label: 'TELUS',
                                    },
                                    {
                                    value: 'vonage',
                                    label: 'Vonage',
                                    },
                                    {
                                    value: 'other',
                                    label: 'Other',
                                    }
                                ]}
                            />
                            <Input
                                id="phone-provider-other-input"
                                style={{ marginTop: '0.5rem',display:( phoneProviderSelection == 'other' ) ? 'inline-flex' : 'none' }}
                                suffix={ phoneProviderOtherValidSuffix }
                                status={ phoneProviderOtherStatus }
                                onChange={handleOnInputChange}
                                placeholder="Enter your provider"
                                defaultValue={ phoneProviderOther }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Internet provider"
                            labelCol={{ span: 24 }}
                            name="internet-provider"
                            rules={[
                                {
                                required: true,
                                message: 'Please select you current internet provider!',
                                },
                            ]}
                        >
                            <Select
                                id="internet-provider-input"
                                name="internet-provider-input"
                                defaultValue="Select"
                                status={ internetProviderStatus }
                                onChange={handleChangeInternetProviderSelection}
                                options={[
                                    {
                                    value: 'start',
                                    label: 'Start.ca',
                                    },
                                    {
                                    value: 'other',
                                    label: 'Other',
                                    }
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Transfer Date"
                            labelCol={{ span: 24 }}
                            name="activation-date"
                            style={{marginBottom:'0', width:'100%'}}
                            rules={[
                                {
                                required: true,
                                message: 'Please input your desired transfer date!',
                                },
                            ]}
                        >
                            <DatePicker 
                                //defaultValue="Select date"
                                disabledDate={disabledDate}
                                status={ transferDateStatus }
                                style={{marginBottom: '24px'}}
                                onChange={onChangeActivationDate}
                            />
                        </Form.Item>
                    </div>

                    <Radio.Group 
                        buttonStyle="solid"
                        onChange={ onRadioTransferChange }
                        style={{ 
                            borderRadius: '8px', 
                            marginBottom: '1rem',
                            border:( radioTransferTypeStatus == 'error' ) ? '1px solid #ff4d4f' : 'none' 
                        }}
                    >
                        <Radio.Button 
                            value="transferring-wired"
                        >
                            I am transferring a wired product
                        </Radio.Button>
                        <Radio.Button 
                            value="transferring-wireless"
                        >
                            I am transferring a wireless product
                        </Radio.Button>
                    </Radio.Group>
                    
                    <div>
                        <Radio.Group 
                            buttonStyle="solid"
                            onChange={ onRadioPlanTypeChange }
                            status={ radioPlanTypeStatus }
                            style={{ 
                                marginTop: '0.5rem', 
                                marginBottom: '1rem',
                                borderRadius: '8px', 
                                display: ( radioTransferType == 'transferring-wireless' ) ? 'inline-block' : 'none', 
                                border:( radioPlanTypeStatus == 'error' ) ? '1px solid #ff4d4f' : 'none' 
                            }}
                        >
                            <Radio.Button 
                                value="payg"
                            >
                                I am on a pay as you go plan
                            </Radio.Button>
                            <Radio.Button 
                                value="monthly"
                            >
                                I am on a monthly plan
                            </Radio.Button>
                        </Radio.Group>
                    </div>

                    <div className="form-column-row">
                        <Form.Item
                            label="IMEI#"
                            labelCol={{ span: 24 }}
                            name="imei-number"
                            style={{ 
                                paddingRight:'1rem',
                                display: ( radioPlanType == 'payg' && radioTransferType == 'transferring-wireless' ) ? 'block' : 'none'
                            }}
                            rules={[
                                {
                                required: true,
                                message: 'Please enter your IMEI#',
                                },
                            ]}
                        >
                            <Input
                                id="transfer-form-imei-number"
                                style={{ width:'80%', marginRight: '0.5rem' }}
                                suffix={ imeiValidSuffix }
                                status={ imeiStatus }
                                onChange={handleOnInputChange}
                                defaultValue={ imeiNumber }
                            />

                            <Tooltip title="Your current provider can provide this number for you.">
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </Form.Item>

                        <Form.Item
                            label="Account#"
                            labelCol={{ span: 24 }}
                            name="wireless-account-number"
                            style={{ 
                                paddingRight:'1rem',
                                display: ( radioPlanType == 'monthly' && radioTransferType == 'transferring-wireless' ) ? 'block' : 'none'
                            }}
                            rules={[
                                {
                                required: true,
                                message: 'Please enter your current wireless provider account#',
                                },
                            ]}
                        >
                            
                            <Input
                                id="transfer-form-wireless-account-number" 
                                suffix={ wirelessAccountValidSuffix }
                                status={ wirelessAccountStatus }
                                onChange={handleOnInputChange}
                                defaultValue={ wirelessAccountNumber }
                            />
                        </Form.Item>

                        
                    </div>

                    <div className='transfer-form-checkbox-container'>
                        <Checkbox
                            style={{ padding:'5px', borderRadius: '8px', marginBottom: '1rem', width:'fit-content', border: ( isAuthorizedAccountHolderStatus == 'error' ) ? '1px solid red' : 'none' }}
                            id="authorized-account-holder-checkbox"
                            onChange={ onCheckboxChange }
                            //checked={ canContactCustomer }
                        >
                            I confirm that I am the authorized account holder and approve the transfer.
                        </Checkbox>
                        <Checkbox
                            style={{ padding:'5px', borderRadius: '8px', marginBottom: '1rem', width:'fit-content', border: ( addressConfirmationStatus == 'error' ) ? '1px solid red' : 'none' }}
                            id="address-confirmation-checkbox"
                            onChange={ onCheckboxChange }
                            //checked={ canContactCustomer }
                        >
                            I confirm the name and address on my phone bill matches the above
                        </Checkbox>
                        <Checkbox
                            style={{ padding:'5px', borderRadius: '8px', marginBottom: '1rem', width:'fit-content', border: ( residentialConfirmationStatus == 'error' ) ? '1px solid red' : 'none' }}
                            id="residential-service-confirmation-checkbox"
                            onChange={ onCheckboxChange }
                            //checked={ canContactCustomer }
                        >
                            I confirm this number is for a residential service
                        </Checkbox>
                    </div>

                    <Button 
                        className='g-recaptcha'
                        style={{ marginTop:'1.5rem' }}
                        onClick={ handleValidateInputs }
                        loading={ formSubmitting }
                        type="primary"
                        //disabled={ ( customerPhoneNumberValid ) ? false : true }
                    >Complete transfer</Button>
                </Form>
            </div>
            { submissionResult }
            { contextHolder }
        </div>
    )
}

export default TransferForm
